module.exports = __webpack_public_path__ + "static/media/Icon_Words.ee34fc99.svg";